import storeModule from '../../store-module'
import { defineStore } from 'pinia'

export default defineStore('customers-generate-contact-message', storeModule.createStoreModule('customers-generate-contact-message'))
